import {Module} from "vuex";

import { asyncRoutes, constantRoutes } from '@/router/index'
import {getUserMenu} from "@/api/jurisdiction";
/**
 * 使用 meta.role 来确定当前用户是否具有权限
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
    } else {
        // return true
        return false
    }
}
/**
 * 格式化后端返回的菜单结构
 * @param menu
 */
function initMenu() {
    let menuList
    let getMenus = localStorage.getItem('menuList')
    let getMenusJson = JSON.parse(getMenus)
    let _import  = require
    let menuRole = [
        {
            name: "permission",
            path: "/permission",
            meta:{
                icon: "chat-square",
                title: "权限管理"
            },
            redirect: "noRedirect",
            children:[
                {
                    name: "personnel",
                    path: "personnel",
                    meta:{
                        icon: "chat-square",
                        title: "角色管理"
                    },
                },
                {
                    name: "permission",
                    path: "permission",
                    meta:{
                        icon: "chat-square",
                        title: "权限管理"
                    },
                }
            ]
        }
    ]
    let p:any = []
    for(let i = 0;i < getMenusJson.length;i++){
       if(getMenusJson[i].children.length === 0){
           p.push({
               name:getMenusJson[i].name,
               path:getMenusJson[i].path,
               meta:{title:getMenusJson[i].title,icon:getMenusJson[i].icon},
               children:getMenusJson[i].children
           })
       }else{
           p.push({
               name:getMenusJson[i].name,
               path:getMenusJson[i].path,
               meta:{title:getMenusJson[i].title,icon:getMenusJson[i].icon},
               children:getChildMenu(getMenusJson[i].children)
           })
       }

    }
    menuList = p
    return menuList
}
function getChildMenu(data){
    let p:any = []
    for(let i = 0;i < data.length;i++){
        if(data[i].children.length === 0){
            p.push({
                name:data[i].name,
                path:data[i].path,
                meta:{title:data[i].title,icon:data[i].icon},
                children:data[i].children
            })
        }else{
            p.push({
                name:data[i].name,
                path:data[i].path,
                meta:{title:data[i].title,icon:data[i].icon},
                children:getChildMenu(data[i].children)
            })
        }
    }
    return p
}
/**
 * 通过递归过滤异步路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
    const res = []

    routes.forEach(route => {
        const tmp = { ...route }
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles)
            }
            res.push(tmp)
        }
    })


    return res
}


const state = {
    routes: [],
    addRoutes: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = constantRoutes.concat(routes)


    }
}

const actions = {
    generateRoutes({ commit }, roles) {
        return new Promise(resolve => {
            // 在这判断是否有权限，哪些角色拥有哪些权限

            let accessedRoutes
            if (roles&&roles.length&&!roles.includes('admin')) {
                accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
            } else {
                accessedRoutes = asyncRoutes || []
                // accessedRoutes = initMenu() || []
            }
            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
        })
    }
}

const permission:Module<any, any> = {
    namespaced:true,
    state,
    mutations,
    actions
}

export default permission
